import { useRef, useState, useEffect, useContext } from 'react';
import axios   from "../../api/axios.js";
import useAuth from '../../hooks/useAuth.js';
import logo from '../../assets/images/Fichier 3icon gallery.png';
import { Link ,useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../../context/AuthProvider.js';

import { useParams } from 'react-router-dom';

const LOGIN_URL = '/login';
function ResetcCrypCode() {
    const { userdata, login } = useContext(AuthContext);

   const { setAuth } = useAuth();

    const navigate=useNavigate();
    const location =useLocation();
    const from=location.state?.from?.pathname||"/";


    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        userRef.current.focus();
        
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd])
    const { id } = useParams();
    const renvoyer = async (e) => {
        e.preventDefault()
        try {
            const response = await axios.get(`reset_password/${id}`,
               
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            ) .then((response) => {
              
                
              });
       
           
                
        } catch (err) {
           
        }
    }
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            const response = await axios.post(`verify_restpassword/${id}`,
            JSON.stringify({
             
                password_rest: pwd,
                
               }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            ) .then((response) => {
                if(response.data['message']=='The provided credentials are incorrect'){
                     setErrMsg('Les chiffres saisis ne correspondent pas à votre code. Veuillez réessayer.');}
                else{
                    navigate(`/UpdatePassword/${id}`,{replace:true});
                }
               
                // navigate("/UpdatePassword",{replace:true});
           
              });
       
           
                
        } catch (err) {
           
        }
    }
  return (
<div className="content-login  row">
                 <div className='logintitle   col-lg-6 '>
                    <div className='logintitle-minisection '>
                 <img src={logo}className='logoImagelogin'/>
            





                    <h1>Bienvenue de retour sur <b>Youth lucc!</b> </h1>
                    <div className="luucshapelogin">
                        <img src={require("../../assets/images/abc-removebg-preview.png")} className=" luucshape" alt="shape4" />
                    </div> 
                    </div>            
                    </div>
                    <div className='loginsection col-lg-4 '>
                    <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>

                        <h4>Entrez le code de sécurité
</h4>
                        <form action="#" method="post" onSubmit={handleSubmit}>
    <div className='patinerpassword'>
        <div  className='patinerpasswordicon'>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
  <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
            </svg>
        </div>
        <div>
<p>        Veuillez patienter quelques minutes pour recevoir votre code à 5 caractères  avant de réessayer.

    </p>        </div>
    </div>
                            <div>
                            Merci de vérifier dans vos e-mails que vous avez reçu un message avec votre code. Celui-ci est composé de 5 caractères.

                            </div>
                        <div className="form-group labellogin  ">
                                    {/* <label htmlFor="password " className="labellogin">Mot de passe</label> */}
                                    <input 
                                    className="form-control" 
                                    type="text"
                                    id="password"
                                    onChange={(e) => setPwd(e.target.value)}
                                    value={pwd}
                                    required
                                    ref={userRef}
                                    placeholder='Entrer le code'
                                    />
                                    </div>
                                    {/* <div className="form-group labellogin  ">
                                    <label htmlFor="password " className="labellogin">Mot de passe</label>
                                    <input 
                                    className="form-control" 
                                    type="password"
                                    id="password"
                                    onChange={(e) => setPwd(e.target.value)}
                                    value={pwd}
                                    required
                                    />
                                    </div>
                                     */}
                                    {/* <div className="d-sm-flex mb-4 align-items-center">
                                    <span className="ml-auto"><Link to='/resetpassword' className="forgot-pass">Mot de passe oublié ?




                    </Link></span> 
                                    </div> */}


<div>
<a onClick={renvoyer} className="forgot-pass">Code non reçu ?</a>
</div>
                                
<div className='btn-continuer-annuler'>
<Link className="btn annulerbttn  ms-3 mb-2 w-100  w-100 " to='/login'>Annuler</Link>
   <button className="btn ms-3 mb-2 w-100" type='submit'>Continuer</button>

</div>

                                    
                            </form>
                            <div>
       <p className='signupOrSignin'>

       <Link  to='/login' >Ce connecter avec le mot de passe</Link> 
       </p></div>
       <div className='logominidev'>
       <img src={logo}className='logomini'/>

       </div>
        
                    </div>
                

                                </div>
  )
}
export default ResetcCrypCode;